import { render, staticRenderFns } from "./applyResultForeign.vue?vue&type=template&id=0f73f058&scoped=true&"
import script from "./applyResultForeign.vue?vue&type=script&lang=js&"
export * from "./applyResultForeign.vue?vue&type=script&lang=js&"
import style0 from "./applyResultForeign.vue?vue&type=style&index=0&id=0f73f058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73f058",
  null
  
)

export default component.exports